export const SCHEDULE_REF_PATTERN =
  /\$\{\s*(?:actions(?:\.\d+|\[\d+\])|by_call_id(?:\.[A-Za-z0-9_-]+|\[['"][^'"]+['"]\]))\.output(?=$|[.[\]])/;

export function containsScheduleReference(value: unknown): boolean {
  if (typeof value === "string") return SCHEDULE_REF_PATTERN.test(value);
  if (Array.isArray(value)) return value.some(containsScheduleReference);
  if (value !== null && typeof value === "object") {
    return Object.values(value).some(containsScheduleReference);
  }
  return false;
}
